import React, {Component} from "react";
import Section from "./layouts/Section";
import {Link} from "react-router-dom";

class ComponentsTable extends Component {
    render() {
        return (
            <Section allNotification={false} searchPopup={true} title={'Table'}>
                <div className="container-inner mg-top-30">
                    <div className="container-fluid">
                        <div className="row flex-row">
                            <div className="col-xl-6">
                                {/* Basic Tabs */}
                                <div className="widget has-shadow">
                                    <div className="widget-header bordered no-actions d-flex align-items-center">
                                        <h4>Simple Table</h4>
                                    </div>
                                    <div className="widget-body sliding-tabs">
                                       <table class="table">
                                            <thead>
                                                <tr>
                                                  <th scope="col">#</th>
                                                  <th scope="col">First</th>
                                                  <th scope="col">Last</th>
                                                  <th scope="col">Handle</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <tr>
                                                  <th scope="row">1</th>
                                                  <td>Mark</td>
                                                  <td>Otto</td>
                                                  <td>@mdo</td>
                                                </tr>
                                                <tr>
                                                  <th scope="row">2</th>
                                                  <td>Jacob</td>
                                                  <td>Thornton</td>
                                                  <td>@fat</td>
                                                </tr>
                                                <tr>
                                                  <th scope="row">3</th>
                                                  <td>Larry</td>
                                                  <td>the Bird</td>
                                                  <td>@twitter</td>
                                                </tr>
                                              </tbody>
                                            </table>
                                    </div>
                                </div>
                                {/* End Basic Tabs */}
                            </div>
                         
                            <div className="col-xl-6">
                                {/* Striped Rows */}
                                <div className="widget has-shadow">
                                    <div className="widget-header bordered no-actions d-flex align-items-center">
                                        <h4>Striped Rows</h4>
                                    </div>
                                    <div className="widget-body sliding-tabs">
                                       <table class="table table-striped">
                                            <thead>
                                                <tr>
                                                  <th scope="col">#</th>
                                                  <th scope="col">First</th>
                                                  <th scope="col">Last</th>
                                                  <th scope="col">Handle</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <tr>
                                                  <th scope="row">1</th>
                                                  <td>Mark</td>
                                                  <td>Otto</td>
                                                  <td>@mdo</td>
                                                </tr>
                                                <tr>
                                                  <th scope="row">2</th>
                                                  <td>Jacob</td>
                                                  <td>Thornton</td>
                                                  <td>@fat</td>
                                                </tr>
                                                <tr>
                                                  <th scope="row">3</th>
                                                  <td>Larry</td>
                                                  <td>the Bird</td>
                                                  <td>@twitter</td>
                                                </tr>
                                              </tbody>
                                            </table>
                                    </div>
                                </div>
                                {/* End Striped Rows */}
                            </div>

                            <div className="col-xl-6">
                                {/* table-hover */}
                                <div className="widget has-shadow">
                                    <div className="widget-header bordered no-actions d-flex align-items-center">
                                        <h4>Table Hover</h4>
                                    </div>
                                    <div className="widget-body sliding-tabs">
                                       <table class="table table-hover">
                                          <thead>
                                            <tr>
                                              <th scope="col">#</th>
                                              <th scope="col">First</th>
                                              <th scope="col">Last</th>
                                              <th scope="col">Handle</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr>
                                              <th scope="row">1</th>
                                              <td>Mark</td>
                                              <td>Otto</td>
                                              <td>@mdo</td>
                                            </tr>
                                            <tr>
                                              <th scope="row">2</th>
                                              <td>Jacob</td>
                                              <td>Thornton</td>
                                              <td>@fat</td>
                                            </tr>
                                            <tr>
                                              <th scope="row">3</th>
                                              <td colspan="2">Larry the Bird</td>
                                              <td>@twitter</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                    </div>
                                </div>
                                {/* End Striped Rows */}
                            </div>
                        </div>
                        {/* End Row */}
                    </div>
                </div>
            </Section>
        );
    }
}

export default ComponentsTable;